// Tiny className joiner — filters out falsy values so we can write
// conditional classes inline without a dependency.
export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}
